import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {akitaConfig, enableAkitaProdMode, persistState} from '@datorama/akita';

import 'hammerjs';
import {debounceTime} from 'rxjs/operators';

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
}

persistState({
  storage: sessionStorage,
  key: `ngx-tkims-${environment.production ? 'prod' : 'uat'}`,
  include: ['akita-session', 'akita-session-cache', 'akita-session-layout'],
  preStorageUpdateOperator: () => debounceTime(500)
});

akitaConfig({
  resettable: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

